import { render, staticRenderFns } from "./NewsDetailsView.vue?vue&type=template&id=d35b4d4e&scoped=true"
import script from "./NewsDetailsView.vue?vue&type=script&lang=js"
export * from "./NewsDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35b4d4e",
  null
  
)

export default component.exports